// Màn hình hiện tại. Màn top-level không cuộn; khối lượng dời vào trang con (UI_SPEC §18).
import { h, type JSX } from 'preact';
import { activeScreen, activeTab } from '@state/modules/ui';
import { ScreenPlaceholder } from './Placeholder';
import { SummonScreen } from './companions/SummonScreen';
import { CultivationScreen } from './character/CultivationScreen';
import { ArtsScreen } from './character/ArtsScreen';
import { CodexScreen } from './destiny/CodexScreen';
import { InventoryScreen } from './character/InventoryScreen';
import { CaveScreen } from './character/CaveScreen';
import { MapScreen } from './world/MapScreen';
import { MarketScreen } from './affairs/MarketScreen';

const SCREENS: Record<string, () => JSX.Element> = {
  'character.cultivation': CultivationScreen,
  'character.arts': ArtsScreen,
  'character.inventory': InventoryScreen,
  'character.cave': CaveScreen,
  'world.map': MapScreen,
  'affairs.market': MarketScreen,
  'destiny.codex': CodexScreen,
  'companions.summon': SummonScreen,
};

export function ScreenHost(): JSX.Element {
  const tab = activeTab.value;
  const screen = activeScreen.value;
  const key = `${tab}.${screen}`;
  return (
    <main class="screen" key={key} data-id="screen" data-screen={key}>
      {SCREENS[key] ? h(SCREENS[key], {}) : <ScreenPlaceholder tab={tab} screen={screen} />}
    </main>
  );
}
